module.exports = __webpack_public_path__ + "d308073b/img/note-list-icon.961c1485.svg";